import clsx from 'clsx'
import { useEffect, useMemo, useState } from 'react'

import { useOverflowStatus } from '../../../hooks/useOverflowStatus'
import Button from './Button'

type Props = {
    lineClamp?: 1 | 2 | 3 | 4 | 5
    children: React.ReactNode
    buttonClassName?: string
}

export function SneakPeek({ children, lineClamp = 3, buttonClassName }: Props) {
    const [isExpanded, setIsExpanded] = useState(false)
    const { ref, overflowing } = useOverflowStatus()
    const [shouldShowButton, setShouldShowButton] = useState(false)

    useEffect(() => {
        setShouldShowButton((s) => s || overflowing)
    }, [overflowing])

    // increases the max height of the component based on the lineClamp prop
    const clampClasses = useMemo(() => {
        if (isExpanded) return 'max-h-[100rem]'
        return {
            1: 'max-h-[1.5rem]',
            2: 'max-h-[3rem]',
            3: 'max-h-[4.5rem]',
            4: 'max-h-[6rem]',
            5: 'max-h-[7.5rem]',
        }[lineClamp]
    }, [lineClamp, isExpanded])

    return (
        <div className="flex flex-col gap-1">
            <div ref={ref} className={clsx('overflow-hidden', clampClasses)}>
                {children}
            </div>

            {shouldShowButton && (
                <Button
                    intent="tertiaryLink"
                    className={clsx('self-start px-0 text-right', buttonClassName)}
                    rightIcon={isExpanded ? 'chevronUp.medium' : 'chevronDown.medium'}
                    onClick={() => setIsExpanded((e) => !e)}
                >
                    {isExpanded ? 'Show less' : 'Show more'}
                </Button>
            )}
        </div>
    )
}
